module.exports = __webpack_public_path__ + "static/media/IL.4a128349.png";